import React from 'react'

import { ContractType } from '../../../../../common/types'
import { RentalPaymentHeader } from './RentalPaymentHeader/RentalPaymentHeader'
import { RightOfOccupancyPaymentHeader } from './RightOfOccupancyPaymentHeader/RightOfOccupancyPaymentHeader'

interface PaymentHeaderProps {
  contractType: ContractType
}

export const PaymentHeader: React.FC<PaymentHeaderProps> = ({
  contractType,
}) => {
  switch (contractType) {
    case ContractType.RENTAL:
      return <RentalPaymentHeader />
    case ContractType.RIGHT_OF_OCCUPANCY:
      return <RightOfOccupancyPaymentHeader />
    default:
      throw new Error(`Unknown contract type: ${contractType}`)
  }
}
